/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsWebRuntimeType;
(function (FxIdDomainSettingsWebRuntimeType) {
    FxIdDomainSettingsWebRuntimeType[FxIdDomainSettingsWebRuntimeType["Desktop"] = 0] = "Desktop";
    FxIdDomainSettingsWebRuntimeType[FxIdDomainSettingsWebRuntimeType["Android"] = 1] = "Android";
    FxIdDomainSettingsWebRuntimeType[FxIdDomainSettingsWebRuntimeType["IPhone"] = 2] = "IPhone";
    FxIdDomainSettingsWebRuntimeType[FxIdDomainSettingsWebRuntimeType["IPad"] = 3] = "IPad";
    FxIdDomainSettingsWebRuntimeType[FxIdDomainSettingsWebRuntimeType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsWebRuntimeType || (FxIdDomainSettingsWebRuntimeType = {}));
export function instanceOfFxIdDomainSettingsWebRuntimeType(value) {
    for (const key in FxIdDomainSettingsWebRuntimeType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsWebRuntimeType, key)) {
            if (FxIdDomainSettingsWebRuntimeType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsWebRuntimeTypeFromJSON(json) {
    return FxIdDomainSettingsWebRuntimeTypeFromJSONTyped(json, false);
}
export function FxIdDomainSettingsWebRuntimeTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsWebRuntimeTypeToJSON(value) {
    return value;
}
export function FxIdDomainSettingsWebRuntimeTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsWebRuntimeType.js.map